export default function UpdateBanner({ onUpdate }) {
  return (
    <div className="update-banner fixed bottom-0 left-0 right-0 bg-green-600 text-white shadow-lg z-40 no-print">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <p className="font-medium">New version available!</p>
          </div>

          <button
            onClick={onUpdate}
            className="px-4 py-2 bg-white text-green-600 rounded-lg font-medium hover:bg-green-50 transition-colors"
          >
            Update Now
          </button>
        </div>
      </div>
    </div>
  );
}
